import React from 'react'

import {useAppDispatch} from '../../hooks/redux'
import {closeModal} from '../../redux/features/modal'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'

type Props = {
  title: string
  content: React.ReactNode
  warning?: boolean
}

const SimpleContentModal = ({title, content, warning = false}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      headline={<Headline label={title} size="l" warning={warning} />}
      onClose={() => dispatch(closeModal())}
      buttons={<Button onClick={() => dispatch(closeModal())}>OK</Button>}
    >
      {content}
    </Modal>
  )
}

export default SimpleContentModal
